export default "__VITE_ASSET__CBLoux21__"